import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Text } from '@lmc/ui-kit/src/general'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

type UnpublishedWarningProps = {
  events: number
  slim?: boolean
}

const UnpublishedWarning = ({
  events,
  slim = false
}: UnpublishedWarningProps) => {
  return (
    <Container slim={slim}>
      <ExclamationIcon />
      <Text level={slim ? 2 : 1}>
        <Trans
          i18nKey="UNPUBLISHED_CHANGES"
          values={{ events }}
          components={{
            builder: (
              <Link
                to={`${window.location.origin}/rota/builder`}
                target="_blank"
                style={{ textDecoration: 'underline' }}
              />
            )
          }}
        />
      </Text>
    </Container>
  )
}

const Container = styled.div<{ slim: boolean }>`
  display: flex;
  padding: ${({ slim }) => (slim ? '4px 8px' : '12px')};
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.color.category.incident};
  background: rgba(255, 51, 102, 0.05);
  color: ${(props) => props.theme.color.neutral.color3};
`

const ExclamationIcon = styled(ExclamationCircleOutlined)`
  font-size: 20px;
  color: ${(props) => props.theme.color.category.incident};
`

export default UnpublishedWarning
